"use client";
import { I18nUtil } from "@utils/i18n";
import Translations from "@translate/components/PlaidImportModal/SectionEmptyState";

import React from "react";
import NextImage from "@components/NextImage";

const I18n = I18nUtil.createScoped(Translations);

export interface SectionEmptyStateProps {
  /** Override default title. */
  title?: string;
  /** Description text shown below title. */
  description?: string;
  /** Invest section shows supported institution logos; non-invest does not. */
  showSupportedLogos?: boolean;
}

/**
 * Empty state for a ConnectionsSection partition.
 * AC-2.9: Invest empty shows "~Nothing here yet~" + description + SupportedLogos.
 * AC-2.10: Non-invest empty shows "~Nothing here yet~" + description without logos.
 */
export const SectionEmptyState: React.FC<SectionEmptyStateProps> = ({
  title,
  description,
  showSupportedLogos = false,
}) => {
  return (
    <div
      className="flex flex-col gap-2 rounded-lg bg-background_white_overlay5 p-8 md:h-50 md:gap-3 flex-center"
      data-testid="section-empty-state"
    >
      <div className="flex flex-col gap-1 flex-center">
        <p className="body_medium_m text-content_tertiary">
          {title ?? I18n.t("Nothing here yet")}
        </p>
        {description && (
          <p className="body_s text-content_quaternary text-center">
            {description}
          </p>
        )}
      </div>
      {showSupportedLogos ? (
        <div
          className="flex flex-row items-center rounded-full px-3 py-2 bg-background_white_overlay5 text-center mx-auto"
          data-testid="section-empty-state-logos"
        >
          <span className="body_s text-content_tertiary">
            {I18n.t("Supports")}
          </span>
          <div className="flex items-center gap-px">
            <NextImage
              src="/assets/images/plaid/supportedlogos_icons.webp"
              alt="Plaid Logo"
              width={76}
              height={16}
            />
          </div>
          <span className="body_s text-content_tertiary">
            {I18n.t("and more")}
          </span>
        </div>
      ) : null}
    </div>
  );
};
